import { confluenceLocalStorageInstance as localStorage, keys } from '@confluence/storage-manager';
import { expValEquals } from '@confluence/feature-experiments';

const MAX_TIMES_SHOWN = 3;

export const checkShouldShowLozenge = () => {
	if (!expValEquals('confluence_hide_live_doc_lozenge', 'isEnabled', true)) {
		return true;
	}
	const currentValue = Number(localStorage.getItem(keys.LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER));

	return currentValue < MAX_TIMES_SHOWN;
};

export const iterateLozengeShownTracker = () => {
	if (!expValEquals('confluence_hide_live_doc_lozenge', 'isEnabled', true)) {
		return;
	}
	const currentValue = Number(localStorage.getItem(keys.LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER));
	localStorage.setItem(keys.LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER, currentValue + 1);
};

export const setLozengeShownTrackerMax = () => {
	if (!expValEquals('confluence_hide_live_doc_lozenge', 'isEnabled', true)) {
		return;
	}
	localStorage.setItem(keys.LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER, MAX_TIMES_SHOWN);
};

// Used for debugging, but exists as a method in case it's useful
export const resetLozengeShownTracker = () => {
	if (!expValEquals('confluence_hide_live_doc_lozenge', 'isEnabled', true)) {
		return;
	}
	localStorage.setItem(keys.LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER, 0);
};
